import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Table } from 'reactstrap';
import { P } from '../../../AbstractElements';
import { BestSellerTableData } from '../../../Data/DashBoard/Ecommerce/BestSellingTable';

const BestSellerTable = () => {
  return (
    <Col xl='8' md="7">
      <Card className='best-seller'>
        <CardBody>
          <Table responsive className='table-bordernone'>
            <thead>
              <tr>
                {BestSellerTableData.header.map((head, i) => (
                  <Fragment key={i}>
                    {i === 0 && <th className='font-primary f-16'>{head}</th>}
                    {i !== 0 && <th>{head}</th>}
                  </Fragment>
                ))}
              </tr>
            </thead>
            <tbody>
              {BestSellerTableData.body.map((item, i) => (
                <tr key={i}>
                  <td>
                    <Link to={`${process.env.PUBLIC_URL}/user-profile`}>
                      <span>{item.title}</span>
                    </Link>
                    <P>{item.subTitle}</P>
                  </td>
                  <td>{item.date}</td>
                  <td>{item.product}</td>
                  <td>{item.Country}</td>
                  <td>${item.total}</td>
                  <td>{item.status}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BestSellerTable;
